// extracted by mini-css-extract-plugin
export var inputUnit = "survey-input-number-module--input-unit--1VJCd";
export var numberInput = "survey-input-number-module--number-input--LtwVo";
export var numberInputWrapper = "survey-input-number-module--number-input-wrapper--goy2f";